// import React from 'react'
// import styled from 'styled-components';
// import SvgComponent from './SvgAnimatoin';

// const ProtectCloudFeatures = () => {
//   return (
//     <div className='svg-animation'>
//       <SvgComponent />
//     </div>
//   )
// }

// export default ProtectCloudFeatures






// const ProctectCloudWrapper = styled.div`
//   .protect-table {
//     display: none;
//   }
//   .svg-animation{
//     width: 100%;
//     margin: 0 auto;
//   }
//   .table-img {
//     display: block;
//     img {
//       width: 100%;
//     }
//   }
//   td {
//     font-size: 12px;
//   }
//   .table td,
//   .table th {
//     padding: 5px;
//   }
//   .bxl {
//     border-left: 2px solid white;
//   }
//   .bxr {
//     border-left: 2px solid white;
//   }
//   table.table {
//     font-size: 12px;
//   }
//   .bx {
//     border: 5px solid white;
//     box-shadow: 0px 0px 9px 0px black;
//   }
//   .w75 {
//     width: 100%;
//   }
//   .w85 {
//     width: 100%;
//   }
//   .pcenter {
//     text-align: center;
//   }
//   padding: 2rem 1rem;
//   .topNav {
//     position: fixed;
//     top: 97px;
//     z-index: 1;
//     background: white;
//     width: 100%;
//     left: 2%;
//   }
//   .navbar-light .navbar-toggler {
//     color: rgba(0, 0, 0, 0.5);
//     border-color: rgba(0, 0, 0, 0);
//   }
//   ul,
//   h1,
//   h2,
//   h6 {
//     text-align: left;
//   }
//   .ptext {
//     text-align: left !important;
//   }
//   h4,
//   h5,
//   h3 {
//     text-align: center;
//   }

//   .w-sm-100 {
//     width: 100%;
//   }
//   .hybridFixed {
//     position: fixed;
//     top: 6rem;
//     left: 0;
//     z-index: 99;
//   }
//   a#bgL,
//   a#bgLL,
//   a#bgLLL {
//     padding: 0.5rem 1.5rem;
//     font-size: 12px;
//     height: auto;
//     text-align: left;
//     cursor: pointer;
//   }
//   a#bgL.active,
//   a#bgLL.active,
//   a#bgLLL.active {
//     text-align: left;
//     border-radius: 0px;
//     padding: 0.5rem 1.5rem;
//     font-size: 12px;
//     height: auto;
//     width: 100%;
//     color: white;
//   }
//   .imgHyb {
//     margin-right: 25px !important;
//     width: 55px !important;
//     z-index: 999;
//     position: relative;
//   }
//   .one {
//     z-index: 99999;
//     background: white;
//     width: 100%;
//   }
//   .one:hover {
//     z-index: 99999;
//     background: rgb(0, 124, 194);
//   }
//   .navbar-light .navbar-nav .nav-link {
//     color: rgba(0, 0, 0, 0.9);
//   }
//   .navbar-light .navbar-nav .nav-link:hover {
//     color: white;
//   }

//   ul.tabList.nav.flex-column {
//     position: relative;
//     z-index: 99999;
//     width: 100%;
//     left: 0rem;
//   }
//   .tabList {
//     display: block;
//     margin-bottom: 4rem;
//   }
//   .tabsHide {
//     display: none;
//     margin-bottom: 4rem;
//   }
//   h1 {
//     font-size: 1.4rem;
//   }
//   h2 {
//     font-size: 1.6rem;
//   }
//   h3 {
//     font-size: 1.2rem;
//   }
//   h4 {
//     font-size: 1.1rem;
//   }
//   .hybmt {
//     margin-top: 2.5rem;
//   }
//   /* .nav-link.active {
// 		background: rgba(0, 0, 0, 0);
// 	} */
//   .logo-btn {
//     font-size: 2rem;
//     background: white;
//     border: none;
//     outline: none;
//     width: 100vw;
//     padding: 0.6rem;
//     text-align: left;
//     box-shadow: 2px 1px 10px rgba(0, 0, 0, 0.3);
//     color: rgba(0, 0, 0, 0.5);
//   }

//   .logo-btn:hover {
//     cursor: pointer;
//   }
//   .tab-content > .active {
//     padding: 0rem;
//   }
//   .w-6 {
//     width: 6rem;
//   }
//   .w-7 {
//     width: 7rem;
//   }
//   .w-8 {
//     width: 8rem;
//   }
//   .position-relative {
//     top: 2rem;
//   }
//   .w-12 {
//     width: 25%;
//   }
//   .magni-img{
//     width: 100%;
//     margin-bottom: 2rem;
//   }

//   @media (min-width: 576px) {
//     .protect-table {
//       display: none;
//     }
//     .svg-animation{
//     width: 80%;
//     margin: 0 auto;
//   }
//     .table-img {
//       display: block;
//       img {
//         width: 100%;
//       }
//     }
//     tr:nth-child(even) {
//       background: #ccc;
//     }
//     .bgclr {
//       background: #f7f8fb !important;
//       border-top: 1px solid balck;
//       border-bottom: 1px solid balck;
//     }
//     .table thead th {
//       vertical-align: middle;
//       border-bottom: 2px solid #dee2e6;
//       background: #007cc2;
//       color: white;
//     }
//     .tdfont {
//       font-size: 14px;
//       text-align: center;
//     }
//     .tdwidth {
//       width: 8rem !important;
//       font-weight: normal;
//       text-align: center;
//       padding: 0px;
//     }
//     .b {
//       border: 0px !important;
//     }
//     .splhead {
//       font-size: 1.3rem !important;
//       line-height: 1.4;
//     }
//     .w75 {
//       width: 60%;
//     }
//     .w85 {
//       width: 85%;
//     }
//     .pcenter {
//       text-align: left;
//     }
//     .ptext {
//       text-align: justify !important;
//     }
//     padding: 2.5rem 4rem;
//     .topNav {
//       position: relative;
//       top: 0px;
//       z-index: 1;
//       width: auto;
//       left: 0px;
//     }
//     .one {
//       z-index: 99999;
//       background: white;
//       width: auto;
//     }
//     .w-12 {
//       width: 5rem;
//     }
//     ul {
//       text-align: justify;
//     }
//     h1,
//     h2,
//     h4,
//     h5,
//     h3 {
//       text-align: left;
//     }
//     .w-sm-100 {
//       width: 75%;
//     }
//     .w-2vh {
//       width: 15vw;
//     }
//     .w-8vh {
//       width: 75vw;
//     }
//     .nav-link.active {
//       background: var(--synectiksBlue);
//       color: var(--synectiksWhite);
//     }
//     .w-85 {
//       width: 100%;
//       border: 1px solid var(--textColor);
//       background: var(--synectiksWhite);
//       justify-content: space-between;
//     }
//     .w-10 {
//       width: 7%;
//       float: left;
//       margin-right: 2rem;
//       margin-bottom: 2rem;
//     }
//     .wsprt {
//       width: 10%;
//       float: left;
//       margin-right: 2rem;
//       margin-bottom: 2rem;
//     }
//     .w-15 {
//       width: 15%;
//       float: left;
//       margin-right: 1.7rem;
//       margin-bottom: 2rem;
//     }
//     .imgSize {
//       width: 15%;
//       float: left;
//       margin-right: 2rem;
//       margin-bottom: 2rem;
//     }

//     ul.nav.flex-column {
//       position: relative;
//       z-index: 99999;
//       width: 100%;
//       /* width: 25vw; */
//       left: 0rem;
//     }
//     .tabList {
//       display: block;
//     }
//     .tabsHide {
//       display: block;
//     }
//     ul.nav.flex-column > li > a {
//       width: 100%;
//       color: rgba(0, 0, 0, 0.8);
//       height: 10vh;
//       font-size: 14px;
//       cursor: pointer;
//       /* padding-left: 3.2rem; */
//     }
//     ul.nav.flex-column > li > a {
//       width: 100%;
//       color: rgba(0, 0, 0, 0.8);
//       height: 10vh;
//       font-size: 15px;
//       cursor: pointer;
//     }
//     .tab-content > .active {
//       padding-top: 0rem;
//       /* padding-right: 4rem;
// 			padding-left: 4rem; */
//       padding-bottom: 2rem;
//     }
//     a#bgL,
//     a#bgLL,
//     a#bgLLL {
//       padding: 0.5rem 2.5rem !important;
//       text-align: left;
//       font-size: 14px;
//     }

//     .logo-btn {
//       display: none;
//     }
//     .himage {
//       width: 50%;
//       height: auto;
//       box-shadow: 5px 5px 5px #789;
//       float: left;
//       margin-right: 2rem;
//       margin-bottom: 10px;
//     }

//     .hbh1 {
//       font-size: 2.5rem;
//     }
//     .hybridFixed {
//       display: block;
//       height: auto;
//       position: sticky;
//       top: 16%;
//       padding-bottom: 21.4rem;
//       padding-top: 2.4rem;
//     }
//     .nav-item > a.active,
//     .nav-item > a:active {
//       height: auto;
//     }
//     h2 {
//       font-size: 2rem;
//     }
//     h3 {
//       font-size: 1.75rem;
//     }
//     h4 {
//       font-size: 1.5rem;
//     }
//     .magni-img{
//       width: 100%;
//     }
//   }
//   @media (min-width: 768px) {
//     .protect-table {
//       display: block;
//     }
//     .svg-animation{
//     width: 60%;
//     margin: 0 auto;
//   }
//     .table-img {
//       display: block;
//       img {
//         width: 50%;
//         display: block;
//         margin: 0 auto;
//       }
//     }
//     a#bgL.active:after {
//       top: 100%;
//       left: 50%;
//       border: solid transparent;
//       content: ' ';
//       height: 0;
//       width: 0;
//       position: absolute;
//       ypointer-events: none;
//       border-color: rgba(136, 183, 213, 0);
//       border-top-color: var(--synectiksBlue);
//       border-width: 20px;
//       margin-left: -20px;
//     }
//     a#bgL.active {
//       border-bottom: 5px solid #007cc2;
//       position: relative;
//       /* padding-left: 1rem !important; */
//       /* background: bgBlue !important; */
//       font-size: 14px;
//     }
//     a#bgLL.active {
//       border-bottom: 5px solid #007cc2;
//       position: relative;
//       /* padding-left: 1rem !important; */
//       /* background: bgBlue !important; */
//       font-size: 14px;
//     }
//     a#bgLL.active:after {
//       top: 100%;
//       left: 50%;
//       border: solid transparent;
//       content: ' ';
//       height: 0;
//       width: 0;
//       position: absolute;
//       pointer-events: none;
//       border-color: rgba(136, 183, 213, 0);
//       border-top-color: var(--synectiksBlue);
//       border-width: 20px;
//       margin-left: -20px;
//     }
//     a#bgLLL.active {
//       position: relative;
//       border-bottom: 5px solid #007cc2;
//       /* padding-left: 1rem !important; */
//       /* background: bgBlue !important; */
//       font-size: 14px;
//     }
//     a#bgLLL.active:after {
//       top: 100%;
//       left: 50%;
//       border: solid transparent;
//       content: ' ';
//       height: 0;
//       width: 0;
//       position: absolute;
//       pointer-events: none;
//       border-color: rgba(136, 183, 213, 0);
//       border-top-color: var(--synectiksBlue);
//       border-width: 20px;
//       margin-left: -20px;
//     }
//     .himage {
//       width: 100%;
//       height: auto;
//       box-shadow: 5px 5px 5px #789;
//       margin-right: 2rem;
//       margin-bottom: 10px;
//     }
//     .magni-img {
//       width: 45%;
//       margin: 2rem auto;
//     }
//   }
//   @media (min-width: 1024px) {
//     .himage {
//       width: 50%;
//       height: auto;
//       box-shadow: 5px 5px 5px #789;
//       float: left;
//       margin-right: 2rem;
//       margin-bottom: 10px;
//     }
//     .magni-img {
//       width: 45%;
//       margin: 2rem auto;
//     }
//   }
// `;























// 
import React from 'react';
import styled from 'styled-components';
import SvgComponent from './SvgAnimatoin'; // Make sure the filename and path are correct

// Define the styled-component with all your styles
const ProctectCloudWrapper = styled.div`
  /* Hides the entire component by default (on mobile screens) */
  display: none;

  .protect-table {
    display: none;
  }
  .svg-animation {
    width: 100%;
    margin: 0 auto;
  }
  .table-img {
    display: block;
    img {
      width: 100%;
    }
  }
  td {
    font-size: 12px;
  }
  .table td,
  .table th {
    padding: 5px;
  }
  .bxl {
    border-left: 2px solid white;
  }
  .bxr {
    border-left: 2px solid white;
  }
  table.table {
    font-size: 12px;
  }
  .bx {
    border: 5px solid white;
    box-shadow: 0px 0px 9px 0px black;
  }
  .w75 {
    width: 100%;
  }
  .w85 {
    width: 100%;
  }
  .pcenter {
    text-align: center;
  }
  padding: 2rem 1rem;
  .topNav {
    position: fixed;
    top: 97px;
    z-index: 1;
    background: white;
    width: 100%;
    left: 2%;
  }
  .navbar-light .navbar-toggler {
    color: rgba(0, 0, 0, 0.5);
    border-color: rgba(0, 0, 0, 0);
  }
  ul,
  h1,
  h2,
  h6 {
    text-align: left;
  }
  .ptext {
    text-align: left !important;
  }
  h4,
  h5,
  h3 {
    text-align: center;
  }

  .w-sm-100 {
    width: 100%;
  }
  .hybridFixed {
    position: fixed;
    top: 6rem;
    left: 0;
    z-index: 99;
  }
  a#bgL,
  a#bgLL,
  a#bgLLL {
    padding: 0.5rem 1.5rem;
    font-size: 12px;
    height: auto;
    text-align: left;
    cursor: pointer;
  }
  a#bgL.active,
  a#bgLL.active,
  a#bgLLL.active {
    text-align: left;
    border-radius: 0px;
    padding: 0.5rem 1.5rem;
    font-size: 12px;
    height: auto;
    width: 100%;
    color: white;
  }
  .imgHyb {
    margin-right: 25px !important;
    width: 55px !important;
    z-index: 999;
    position: relative;
  }
  .one {
    z-index: 99999;
    background: white;
    width: 100%;
  }
  .one:hover {
    z-index: 99999;
    background: rgb(0, 124, 194);
  }
  .navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, 0.9);
  }
  .navbar-light .navbar-nav .nav-link:hover {
    color: white;
  }

  ul.tabList.nav.flex-column {
    position: relative;
    z-index: 99999;
    width: 100%;
    left: 0rem;
  }
  .tabList {
    display: block;
    margin-bottom: 4rem;
  }
  .tabsHide {
    display: none;
    margin-bottom: 4rem;
  }
  h1 {
    font-size: 1.4rem;
  }
  h2 {
    font-size: 1.6rem;
  }
  h3 {
    font-size: 1.2rem;
  }
  h4 {
    font-size: 1.1rem;
  }
  .hybmt {
    margin-top: 2.5rem;
  }
  /* .nav-link.active {
    background: rgba(0, 0, 0, 0);
  } */
  .logo-btn {
    font-size: 2rem;
    background: white;
    border: none;
    outline: none;
    width: 100vw;
    padding: 0.6rem;
    text-align: left;
    box-shadow: 2px 1px 10px rgba(0, 0, 0, 0.3);
    color: rgba(0, 0, 0, 0.5);
  }

  .logo-btn:hover {
    cursor: pointer;
  }
  .tab-content > .active {
    padding: 0rem;
  }
  .w-6 {
    width: 6rem;
  }
  .w-7 {
    width: 7rem;
  }
  .w-8 {
    width: 8rem;
  }
  .position-relative {
    top: 2rem;
  }
  .w-12 {
    width: 25%;
  }
  .magni-img {
    width: 100%;
    margin-bottom: 2rem;
  }

  /*
    * This media query is for small tablets and up.
    * The component is not visible below this screen width.
  */
  @media (min-width: 768px) {
    /* Makes the component visible on screens 768px and wider */
    display: block;

    .protect-table {
      display: block;
    }
    .svg-animation {
      width: 60%;
      margin: 0 auto;
    }
    .table-img {
      display: block;
      img {
        width: 50%;
        display: block;
        margin: 0 auto;
      }
    }
    a#bgL.active:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      ypointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-top-color: var(--synectiksBlue);
      border-width: 20px;
      margin-left: -20px;
    }
    a#bgL.active {
      border-bottom: 5px solid #007cc2;
      position: relative;
      font-size: 14px;
    }
    a#bgLL.active {
      border-bottom: 5px solid #007cc2;
      position: relative;
      font-size: 14px;
    }
    a#bgLL.active:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-top-color: var(--synectiksBlue);
      border-width: 20px;
      margin-left: -20px;
    }
    a#bgLLL.active {
      position: relative;
      border-bottom: 5px solid #007cc2;
      font-size: 14px;
    }
    a#bgLLL.active:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-top-color: var(--synectiksBlue);
      border-width: 20px;
      margin-left: -20px;
    }
    .himage {
      width: 100%;
      height: auto;
      box-shadow: 5px 5px 5px #789;
      margin-right: 2rem;
      margin-bottom: 10px;
    }
    .magni-img {
      width: 45%;
      margin: 2rem auto;
    }
    .pcenter {
      text-align: left;
    }
    .ptext {
      text-align: justify !important;
    }
    padding: 2.5rem 4rem;
    .topNav {
      position: relative;
      top: 0px;
      z-index: 1;
      width: auto;
      left: 0px;
    }
    ul {
      text-align: justify;
    }
    h1,
    h2,
    h4,
    h5,
    h3 {
      text-align: left;
    }
    /* ... other desktop styles from your original code ... */
  }

  @media (min-width: 1024px) {
    .himage {
      width: 50%;
      height: auto;
      box-shadow: 5px 5px 5px #789;
      float: left;
      margin-right: 2rem;
      margin-bottom: 10px;
    }
    .magni-img {
      width: 45%;
      margin: 2rem auto;
    }
  }

  /* Note: I've removed the redundant @media (min-width: 576px) block as its rules were overridden by the 768px block. */
`;

// Define your component and use the styled-component
const ProtectCloudFeatures = () => {
  return (
    <ProctectCloudWrapper>
      <div className='svg-animation'>
        <SvgComponent />
      </div>
    </ProctectCloudWrapper>
  );
};

export default ProtectCloudFeatures;